<template>

    <div v-if="transactionType && entityTo">

        <b-modal v-model="showModal" :title="transactionTypeFilter + ' ' + entityTo.name"
                 hide-footer centered>

            <div>
                <b-row>
                    <b-col cols="5">

                        <div class="d-flex flex-column h-100" style="margin-top: 5px">

                            <span class="font-small-3">{{ $t('labels.toWallet') }}:</span>

                            <b-badge
                                    style="max-width: 200px; white-space: nowrap; text-overflow: ellipsis;overflow: hidden"
                                    :to="{ name: 'wallets-detail', params: { id: toWallet } }"
                                    variant="primary">{{ `${toWallet}` }}
                            </b-badge>

                            <div class="d-flex align-items-center justify-content-center"
                                 style="width: 100% !important;height: 100%!important;">

                                <b-img fluid :src="transactionType.includes('credit') ? creditUrl : debitUrl"
                                       alt="transferImg" style="width: 80%" class="pb-4"/>

                            </div>

                        </div>

                    </b-col>
                    <b-col>

                        <validation-observer ref="transferRules">
                            <b-form>
                                <b-row>

                                    <b-col cols="12" class="mt-14">

                                        <b-form-group label="Amount to recharge">
                                            <template #label>{{
                                                transactionType.includes('credit')
                                                ? $t('labels.amountToRecharge')
                                                : $t('labels.amountToDebit')
                                                }}
                                            </template>
                                            <validation-provider
                                                    #default="{ errors }"
                                                    name="amount"
                                                    rules="required|min:0"
                                                    ref="AmountInput"
                                            >
                                                <money
                                                        v-model="amount"
                                                        v-bind="{
                                                      suffix: selectedCurrency ? ` ${selectedCurrency.abv}` : ' ',
                                                      masked: false
                                                    }"
                                                        class="form-control font-weight-bold"
                                                />

                                                <small class="text-danger">{{ errors[0] }}</small>
                                                <!--                                            <small v-if="validWalletAmounTranferir" class="text-danger"-->
                                                <!--                                            >The amount cannot be greater than your balance</small-->
                                                <!--                                            >-->
                                            </validation-provider>
                                        </b-form-group>

                                        <b-form-group :label="$t('labels.currencyType')">
                                            <validation-provider
                                                    #default="{ errors }"
                                                    name="Currency Name"
                                                    rules="required"
                                            >
                                                <v-select v-model="selectedCurrency"
                                                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                          :options="currencies"
                                                          style="min-width: 150px"
                                                          :clearable="false"
                                                          label="name"/>

                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>

                                        <b-form-group :label="$t('labels.detail')">
                                            <validation-provider
                                                    #default="{ errors }"
                                                    name="Transaction Detail"
                                                    rules="required"
                                            >
                                                <b-form-input
                                                        v-model="transactionDetail"
                                                        :state="errors.length > 0 ? false : null"
                                                        :placeholder="$t('labels.detail')"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>

                                    </b-col>
                                </b-row>

                                <b-row class="mb-1 mt-1 d-flex justify-content-center">
                                    <b-col cols="12">

                                        <b-button style="width: 100%" variant="primary"
                                                  type="submit"
                                                  @click.prevent="makeTransfer">
                                            {{$t('buttons.makeTransfer')}}
                                        </b-button>

                                    </b-col>
                                </b-row>

                            </b-form>

                        </validation-observer>

                    </b-col>

                </b-row>

            </div>

        </b-modal>
    </div>

</template>

<script>
  import {
    BAlert,
    BBadge,
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    BLink,
    BRow,
    BSpinner,
  } from 'bootstrap-vue'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { mapActions } from 'vuex'
  import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
  import vSelect from 'vue-select'

  export default {
    name: 'Transfer',
    components: {
      BImg,
      BFormSelect,
      BBadge,
      BRow,
      BCol,
      BLink,
      BFormGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroup,
      BForm,
      BButton,
      BAlert,
      BSpinner,
      VueTypeaheadBootstrap,
      ValidationProvider,
      ValidationObserver,
      vSelect,
    },
    data() {
      return {
        transaction: {
          amount: 0,
        },
        fromWallet: '',
        toWallet: '',
        entityFrom: {},
        entityTo: {},
        transactionDetail: '',
        transactionType: '',
        showModal: false,
        text: '',
        amount: '',
        query: '',
        currencies: [],
        selectedCurrency: '',
        debitUrl: require('@/assets/images/pages/shared/banckMoney.png'),
        creditUrl: require('@/assets/images/pages/shared/money.png'),
      }
    },

    computed: {

      transactionTypeFilter() {
        if (this.transactionType.includes('credit'))
          return this.$t('labels.creditTo')
        else
          return this.$t('labels.debitTo')
      },

    },

    methods: {
      ...mapActions('transaction', ['store']),
      ...mapActions('currency', ['currencys']),
      ...mapActions('wallet', ['show', 'transferBetweenUsers', 'transferAdminClient', 'transferAgentUser']),

      showTransactionModal(fromWallet, toWallet, entityFrom, entityTo, transactionType) {
        this.fromWallet = fromWallet
        this.toWallet = toWallet
        this.entityFrom = entityFrom
        this.entityTo = entityTo
        this.transactionType = transactionType

        this.show(toWallet)
          .then(response => {
            this.selectedCurrency = response.defaultCurrency
            this.currencies = this.activatedCurrencies(response)
          })

        this.showModal = true
      },

      activatedCurrencies(walletData) {
        return walletData.currencies.filter(currency => currency.active).map(currency => {
          return Object.assign({}, currency.currency)
        })
      },

      hideTransactionModal() {
        this.resetForm()
        this.showModal = false
      },

      makeTransfer() {
        this.$refs.transferRules.validate()
          .then(success => {
            try {

              if (success) {

                const user = JSON.parse(localStorage.getItem('userData'))

                if (this.transactionType.includes('User')) {

                    const request = {
                      operation: {
                        mainUserId: this.entityFrom.entity,
                        secondaryUserId: this.entityTo.entity,
                        currencyId: this.selectedCurrency._id,
                        amount: this.amount,
                        description: this.transactionDetail,
                        executorId : user._id
                      },
                    }

                    if ((this.entityTo.entity === this.entityFrom.entity) && user.role === 'root' && this.transactionType.includes('credit')){
                        request.operation.type = 'ROOT_CREDIT'
                    } else if ((this.entityTo.entity === this.entityFrom.entity) && user.role === 'root' && this.transactionType.includes('debit')){
                        request.operation.type = 'ROOT_DEBIT'
                    } else if (this.transactionType.includes('credit')) {
                        request.operation.type = 'TO_USER'
                    } else if (this.transactionType.includes('debit')) {
                      request.operation.type = 'FROM_USER'
                    }

                    this.$transferBetweenUsers(request)

                }

              }

            } catch (error) {

              this.$swal({
                title: this.$t('labels.error'),
                text: error.message,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })

            }

          })

      },

      resetForm() {
        this.fromWallet = ''
        this.toWallet = ''
        this.entityFrom = ''
        this.entityTo = ''
        this.transactionType = ''
        this.amount = ''
        this.query = ''
        this.selectedCurrency = ''
        this.transactionDetail = ''
      },

      $transferAdminClient(request) {
        this.transferAdminClient(request)
          .then(response => {

            this.$swal({
              title: this.$t('labels.successfulTransfer'),
              text: response.message,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            this.hideTransactionModal()

          })
          .catch(error => {
            this.$swal({
              icon: 'error',
              title: this.$t('labels.incorrectTransfer'),
              text: error.message,
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
          })
      },

      $transferBetweenUsers(request) {
        this.transferBetweenUsers(request)
          .then(response => {

            this.$swal({
              title: this.$t('labels.successfulTransfer'),
              text: response.message,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            this.hideTransactionModal()

          })
          .catch(error => {
            this.$swal({
              icon: 'error',
              title: this.$t('labels.incorrectTransfer'),
              text: error.message,
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
          })
      },

      $transferAgentUser(request) {
        this.transferAgentUser(request)
            .then(response => {

              this.$swal({
                title: this.$t('labels.successfulTransfer'),
                text: response.message,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })

              this.hideTransactionModal()

            })
            .catch(error => {
              this.$swal({
                icon: 'error',
                title: this.$t('labels.incorrectTransfer'),
                text: error.message,
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              })
            })
      },

    },

  }
</script>

<style scoped>

</style>